// extracted by mini-css-extract-plugin
module.exports = {"container":"Thanks_container__8hYVL","completed":"Thanks_completed__2P6vj","title":"Thanks_title__1-eCP","icon":"Thanks_icon__1oGpA"};